import { render, staticRenderFns } from "./MeasurementField.vue?vue&type=template&id=d5a33e3e"
import script from "./MeasurementField.vue?vue&type=script&lang=js"
export * from "./MeasurementField.vue?vue&type=script&lang=js"
import style0 from "./MeasurementField.vue?vue&type=style&index=0&id=d5a33e3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports